{
    "name": "Multi-Router",
    "abi": [
        {
            "inputs": [
                {
                    "name": "amountIn",
                    "type": "uint256"
                },
                {
                    "name": "path",
                    "type": "address[]"
                }
            ],
            "name": "getAmountsOut",
            "outputs": [
                {
                    "name": "amounts",
                    "type": "uint256[]"
                }
            ],
            "stateMutability": "view",
            "type": "function"
        },
        {
            "inputs": [
                {
                    "name": "path",
                    "type": "bytes"
                },
                {
                    "name": "amountIn",
                    "type": "uint256"
                }
            ],
            "name": "quoteExactInput",
            "outputs": [
                {
                    "name": "amountOut",
                    "type": "uint256"
                },
                {
                    "name": "sqrtPriceX96AfterList",
                    "type": "uint160[]"
                },
                {
                    "name": "initializedTicksCrossedList",
                    "type": "uint32[]"
                },
                {
                    "name": "gasEstimate",
                    "type": "uint256"
                }
            ],
            "stateMutability": "nonpayable",
            "type": "function"
        }
    ]
}